import { NextApiRequest } from 'next'
import { NextRequest } from 'next/server'

const stripURLToHostname = (url: string): string => {
  return url
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .split(':')[0]
    .split('/')[0]
}

// Helper to read header values from both Next.js request types (NextApiRequest & NextRequest)
const getHeader = (request: NextApiRequest | NextRequest, name: string): string | null => {
  const { headers } = request as { headers?: unknown }
  if (!headers) return null

  // In the Edge runtime `headers` is an instance of `Headers`.
  if (typeof (headers as Headers).get === 'function') {
    return (headers as Headers).get(name) ?? null
  }

  // In API routes `headers` is a plain object.
  const value = (headers as Record<string, string | string[] | undefined>)[name]
  if (Array.isArray(value)) return value[0] ?? null
  return value ?? null
}

export const getSubdomain = (request: NextApiRequest | NextRequest): string | null => {
  // Explicit override – primarily for the chrome extension because there is no subdomain on the origin header
  const explicit = getHeader(request, 'x-scalis-subdomain')
  if (explicit) return explicit

  // Prefer `origin`, fall back to `host`.
  const originOrHost = getHeader(request, 'origin') ?? getHeader(request, 'host') ?? ''

  return getSubdomainFromURL(originOrHost)
}

export const getSubdomainFromURL = (url: string): string | null => {
  const appDomain = stripURLToHostname(process.env.NEXT_PUBLIC_DOMAIN || '')

  if (!url || !appDomain) return null

  const subdomain = stripURLToHostname(url).replace(`.${appDomain}`, '').replace(appDomain, '')

  if (url === subdomain || !subdomain) {
    return null
  }

  return subdomain
}
